import { RegisterWithoutPassword } from "shared/providers/context/types/auth-context";

import { IInformations } from "@CheckoutStepsOffers/provider";

export const getRegisterUserPayload = (
  data: IInformations,
): RegisterWithoutPassword => {
  const payload: RegisterWithoutPassword = {
    ...data,
    email: data.email,
    display_name: data.name,
  };

  if (data.phone_number) {
    let phone_number = data.phone_number;
    if (!phone_number.startsWith("+")) {
      phone_number = `+${phone_number}`;
    }
    phone_number =
      phone_number[0] + phone_number.slice(1).replace(/[^0-9]/g, "");
    payload.phone_number = phone_number;
  }

  if (data.document) {
    payload.document = data.document.replace(/[^0-9]/g, "");
  }

  return payload;
};
